import React from 'react';

const MyApplicationMapIcon = (props) => (
  <svg
    id="Component_25_1"
    data-name="Component 25 – 1"
    xmlns="http://www.w3.org/2000/svg"
    width="56.252"
    height="50.114"
    viewBox="0 0 56.252 50.114"
    {...props}
  >
    <path
      id="Path_883"
      data-name="Path 883"
      d="M-800.356-497a1.247,1.247,0,0,0-1.245,1.245,1.226,1.226,0,0,0,.09.446,1.241,1.241,0,0,0,1.154.8,1.245,1.245,0,0,0,1.245-1.245c0-.039-.02-.073-.023-.112A1.235,1.235,0,0,0-800.356-497Z"
      transform="translate(818.142 508.26)"
      fill="none"
    />
    <path
      id="Path_884"
      data-name="Path 884"
      d="M-791.233-488.69l-8.051,2.964-.036.322-1.348,11.917-1.133,10.015,10.569-3.313v-21.9Z"
      transform="translate(818.114 509.448)"
      fill="none"
    />
    <circle
      id="Ellipse_6"
      data-name="Ellipse 6"
      cx="1.244"
      cy="1.244"
      r="1.244"
      transform="translate(38.738 9.346)"
      fill="none"
    />
    <path
      id="Path_885"
      data-name="Path 885"
      d="M-774.2-489.708l-6.075,3.769.782,6.909,1.279,11.3.449,3.97,9.122-5.348-.22-.816-2.943-10.911Z"
      transform="translate(821.188 509.302)"
      fill="none"
    />
    <circle
      id="Ellipse_7"
      data-name="Ellipse 7"
      cx="1.244"
      cy="1.244"
      r="1.244"
      transform="translate(27.351 3.429)"
      fill="none"
    />
    <path
      id="Path_886"
      data-name="Path 886"
      d="M-782.365-485.765l-6.377-2.54-.812-.323v22.044l3.012.965,6.7,2.146-.41-3.621-1.279-11.3Z"
      transform="translate(819.864 509.457)"
      fill="none"
    />
    <path
      id="Path_887"
      data-name="Path 887"
      d="M-801.119-485.932l-6.151-3.783-1.927,7.145-3.34,12.385-.291,1.081,9.2,5.391.995-8.794,1.348-11.917Z"
      transform="translate(816.538 509.301)"
      fill="none"
    />
    <path
      id="Path_888"
      data-name="Path 888"
      d="M-804.091-461.8a1.68,1.68,0,0,0,.381.16c.034.01.07.015.105.023.059.013.118.032.179.039s.125.009.187.01h.006a1.692,1.692,0,0,0,.512-.08l13.407-4.2c.041.009.085.011.128.017l13.057,4.183a1.744,1.744,0,0,0,.459.072c.021,0,.042.01.064.01s.029-.007.043-.007.022.006.033.006a1.871,1.871,0,0,0,.2-.01,1.708,1.708,0,0,0,.957-.437l12.237-7.175a1.716,1.716,0,0,0,.788-1.925l-.531-1.97-3.339.783.219.816-9.121,5.349-.449-3.97-3.361.789.41,3.622-6.7-2.146-21.554,5.056,1.678.984Z"
      transform="translate(817.545 511.678)"
      fill="#b95700"
    />
    <path
      id="Path_889"
      data-name="Path 889"
      d="M-769.924-470.934l3.339-.783-2.943-10.911-3.34.783Z"
      transform="translate(822.246 510.314)"
      fill="#eb6909"
    />
    <path
      id="Path_890"
      data-name="Path 890"
      d="M-782.534-479.576l1.279,11.3,3.361-.788-1.279-11.3Z"
      transform="translate(820.865 510.637)"
      fill="#eb6909"
    />
    <path
      id="Path_891"
      data-name="Path 891"
      d="M-785.765-468.1v-9.93l-3.429.8v8.915l-10.569,3.313,1.134-10.015-3.544.832-1,8.794-9.2-5.392.291-1.08-3.791.889-.152.562a1.716,1.716,0,0,0,.789,1.925l10.92,6.4,21.554-5.056Z"
      transform="translate(816.074 510.971)"
      fill="#eb6909"
    />
    <path
      id="Path_892"
      data-name="Path 892"
      d="M-802.563-484.983l-1.348,11.917,3.544-.831,1.348-11.917Z"
      transform="translate(817.812 509.859)"
      fill="#5f9501"
    />
    <path
      id="Path_893"
      data-name="Path 893"
      d="M-808.76-483.464l-3.79.889-3.34,12.385,3.79-.889Z"
      transform="translate(816.101 510.194)"
      fill="#5f9501"
    />
    <path
      id="Path_894"
      data-name="Path 894"
      d="M-792.554-487.374v11.6l3.429-.8v-11.6Z"
      transform="translate(819.435 509.521)"
      fill="#5f9501"
    />
    <path
      id="Path_895"
      data-name="Path 895"
      d="M-782.466-485.258l.834,7.37,3.361-.788-.782-6.909,6.074-3.769,2.394,8.875,3.34-.783-2.943-10.911-7.636,1.791-3.222,2-1.965-.783-5.831,1.368Z"
      transform="translate(819.965 508.95)"
      fill="#5f9501"
    />
    <path
      id="Path_896"
      data-name="Path 896"
      d="M-771.647-492.277a1.709,1.709,0,0,0-1.025-1.147,1.709,1.709,0,0,0-1.534.137l-5,3.1,7.636-1.792Z"
      transform="translate(821.342 508.754)"
      fill="#79b61d"
    />
    <path
      id="Path_897"
      data-name="Path 897"
      d="M-807.25-489.168l6.151,3.783-.17,1.506,3.544-.832.037-.321,8.051-2.964v1.388l3.429-.8v-.513l.813.323,5.831-1.368-7.689-3.062,0,0-.031-.011c-.008,0-.016,0-.024-.006a1.721,1.721,0,0,0-.57-.112l-.023,0-.017,0a1.68,1.68,0,0,0-.549.1c-.015,0-.03,0-.043.007l-10.569,3.89-8.325-5.119a1.716,1.716,0,0,0-1.53-.134,1.715,1.715,0,0,0-1.023,1.148l-3,11.143,3.79-.889Z"
      transform="translate(816.518 508.754)"
      fill="#79b61d"
    />
    <path
      id="Path_898"
      data-name="Path 898"
      d="M-785.179-497.116a4.678,4.678,0,0,0,4.673,4.672,4.678,4.678,0,0,0,4.673-4.672,4.659,4.659,0,0,0-1.927-3.763l-6.87,1.611A4.611,4.611,0,0,0-785.179-497.116Zm4.673-1.245a1.245,1.245,0,0,1,1.245,1.245,1.245,1.245,0,0,1-1.245,1.243,1.246,1.246,0,0,1-1.245-1.243A1.246,1.246,0,0,1-780.506-498.36Z"
      transform="translate(820.489 507.706)"
      fill="#79b61d"
    />
    <path
      id="Path_899"
      data-name="Path 899"
      d="M-799.951-491.126a4.678,4.678,0,0,0,4.673-4.673,4.671,4.671,0,0,0-.09-.9l-3.361.787c0,.039.023.073.023.112a1.245,1.245,0,0,1-1.245,1.245,1.241,1.241,0,0,1-1.154-.8l-3.334.783A4.666,4.666,0,0,0-799.951-491.126Z"
      transform="translate(817.737 508.304)"
      fill="#79b61d"
    />
    <path
      id="Path_900"
      data-name="Path 900"
      d="M-785.8-502.18a4.678,4.678,0,0,0-4.673-4.673,4.678,4.678,0,0,0-4.673,4.673,4.679,4.679,0,0,0,4.673,4.673A4.679,4.679,0,0,0-785.8-502.18Zm-5.918,0a1.246,1.246,0,0,1,1.245-1.245,1.245,1.245,0,0,1,1.244,1.245,1.246,1.246,0,0,1-1.244,1.245A1.247,1.247,0,0,1-791.714-502.18Z"
      transform="translate(819.065 506.853)"
      fill="#c8d200"
    />
    <path
      id="Path_901"
      data-name="Path 901"
      d="M-784.7-499.154l6.87-1.611a4.633,4.633,0,0,0-2.746-.91A4.659,4.659,0,0,0-784.7-499.154Z"
      transform="translate(820.557 507.593)"
      fill="#c8d200"
    />
    <path
      id="Path_902"
      data-name="Path 902"
      d="M-801.173-495.328a1.247,1.247,0,0,1,1.245-1.245,1.235,1.235,0,0,1,1.222,1.133l3.361-.787A4.679,4.679,0,0,0-799.928-500a4.678,4.678,0,0,0-4.673,4.673,4.6,4.6,0,0,0,.185,1.229l3.334-.783A1.226,1.226,0,0,1-801.173-495.328Z"
      transform="translate(817.713 507.832)"
      fill="#c8d200"
    />
  </svg>
);

export default MyApplicationMapIcon;
